<template>
  <div class="portfolio portfolio--mobile">
    <PortfolioList/>
  </div>

</template>

<script>

  // @ is an alias to /src
  import PortfolioList from '@/components/PortfolioList.vue'

  export default {
    name: 'portfolio',
    components: {
      PortfolioList
    }
  }

</script>

<style scoped lang="scss">
  .portfolio--mobile {
    padding-top: 30px;
  }
</style>